import { render, staticRenderFns } from "./userAction.vue?vue&type=template&id=495a3ce8&"
import script from "./userAction.vue?vue&type=script&lang=js&"
export * from "./userAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports